<template>
  <div class="mt-3 align-items-end d-flex justify-content-end">
    <div v-if="isVisibleSubmit">
      <b-button
        :to="{ name: routeName }"
        variant="secondary"
        class="ml-1 border-primary text-primary"
      >
        {{ $t("actions.back") }}
      </b-button>
      <b-button
        variant="primary"
        class="ml-1"
        @click.prevent.stop="save"
        v-if="draftStatus"
      >
        {{ $t("actions.save") }}
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    routeName: {
      type: String,
      required: true
    },
    isVisibleSubmit: {
      type: Boolean,
      required: false,
      default: true
    },
    draftStatus: {
      type: Boolean,
      require: false,
      default: true
    }
  },
  methods: {
    save() {
      this.$emit('save')
    }
  }
}
</script>
